<template>
    <div id="header" :class="{ fixed: isHeaderFixed }">
        <div class="header_wrap">
            <button type="button" class="menu_btn" @click="toggleOpen">
                <i></i>
                <i></i>
                <i></i>
            </button>
            <span class="logo" @click="$router.push('/')">META HEALTH</span>
        </div>
    </div>
</template>

<script lang="ts">
import { globalStore, reactive, watch, onMounted, onUnmounted } from "@/BaseComponent";
import { ref } from "vue";

export default {
    setup() {
        const global = globalStore();
        const state = reactive({
            isNavOpen: false,
        });
        const isHeaderFixed = ref(false);

        watch(global, () => {
            state.isNavOpen = global.isNavOpen;
        });

        const toggleOpen = () => {
            state.isNavOpen = !state.isNavOpen;
            global.setNavOpen(state.isNavOpen);
        };

        const handleScroll = () => {
            const headerHeight = document.querySelector(".header_wrap")?.clientHeight || 0;
            isHeaderFixed.value = window.scrollY > headerHeight;
        };

        onMounted(() => {
            window.addEventListener("scroll", handleScroll);
        });

        onUnmounted(() => {
            window.removeEventListener("scroll", handleScroll);
        });

        return {
            toggleOpen,
            isHeaderFixed,
        };
    },
};
</script>

<style scoped>
.fixed {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
}
</style>
